import PropTypes from 'prop-types'
import React from 'react'
import { Flex } from 'components/Layout'

export const CardSelectItem = ({ onClick, children, ...rest }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    height="100%"
    width="100%"
    onClick={onClick}
  >
    {typeof children === 'function' ? children(rest) : children}
  </Flex>
)

CardSelectItem.propTypes = {
  isErrorable: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
}
